import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const BottomNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    {
      path: '/',
      name: '选课中心',
      icon: '📚',
      active: location.pathname === '/' || location.pathname.startsWith('/courses')
    },
    {
      path: '/my',
      name: '我的',
      icon: '👤',
      active: location.pathname === '/my'
    }
  ];

  const handleNavClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="bottom-navigation">
      {navItems.map((item) => (
        <div
          key={item.path}
          className={`nav-item ${item.active ? 'active' : ''}`}
          onClick={() => handleNavClick(item.path)}
        >
          <div className="nav-icon">{item.icon}</div>
          <div className="nav-label">{item.name}</div>
        </div>
      ))}
    </div>
  );
};

export default BottomNav;